import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import styles from './A_SelectItem.module.css';
import cn from 'classnames';
import { useEffect, useRef } from 'react';

interface A_SelectItemProps {
  label: string;
  size: 'thin' | 'wide';
  onClick: () => void;
  isOpened: boolean;
}

export default function A_SelectItem({
  label,
  size,
  onClick,
  isOpened,
}: A_SelectItemProps) {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    onClick();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    switch (event.key) {
      case 'Escape':
        onClick();
        triggerRef.current?.focus();
        break;
      case 'ArrowDown':
        event.preventDefault();
        if (!isOpened) {
          onClick();
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (!isOpened) {
          onClick();
        }
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        handleToggle();
        break;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        onClick();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClick]);

  return (
    <div className={styles.button_wrapper}>
      <button
        ref={triggerRef}
        type='button'
        className={cn(styles.wrapper, 'text-p-4', styles[size], {
          [styles.opened]: isOpened,
        })}
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        aria-haspopup='listbox'
        aria-expanded={isOpened}
        aria-labelledby='select-item-label'
      >
        <span className={styles.label}>{label}</span>
        <div
          className={cn(styles.arrow_wrapper, { [styles.arrow_up]: isOpened })}
        >
          <Q_Icon.DropdownArrowIcon width={12} height={6} fill='none' />
        </div>
      </button>
      {isOpened && (
        <div
          className={cn(styles.list_plate, {
            [styles.thin_plate]: size === 'thin',
            [styles.wide_plate]: size === 'wide',
          })}
        ></div>
      )}
    </div>
  );
}
